<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <k-p-i-value-boxes></k-p-i-value-boxes>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Optimisation Savings
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 lg9 v-if="data">
                        <vue-plotly :data="data" :layout="layout" :options="options" ref="plotly"/>
                    </v-flex>
                    <v-flex xs12 lg3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <value-box :value="totalSavingSum" unit="kWh" title="Saving after optimisation" icon="fa-piggy-bank"></value-box>
                            </v-flex>
                            <v-flex xs12>
                                <value-box :value="totalPowerSum" unit="kWh" title="Actual usage after optimisation" icon="fa-bolt"></value-box>
                            </v-flex>
                            <v-flex xs12>
                                <value-box :value="savingPercentage" unit="%" title="Saving" icon="fa-smile" class="green-icon"></value-box>
                            </v-flex>

                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-flex xs12 v-show="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    Energy Consumption Trend
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 v-if="data2">
                        <vue-plotly :data="data2" :layout="layout2" :options="options2"/>

                        <vue-plotly v-for="equipData in data2" v-if="equipData.hasOwnGraph" :data="[equipData]" :layout="{'title':equipData.name,'yaxis':{'title':'Energy consumption'},'xaxis':{'title':'Date'}}" :options="{}"/>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <v-flex xs12 v-show="!loading">
            <cooling-load-stacked-area-plot agg="H"></cooling-load-stacked-area-plot>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <cooling-load-forecast-new></cooling-load-forecast-new>
        </v-flex>
        <v-flex xs6 v-show="!loading">
            <v-card>
                <v-card-title class="accent white--text title">
                    Latest Cooling Load Forecast Accuracy
                    <v-spacer></v-spacer>
                    <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
                        <v-icon>fa-info</v-icon>
                    </v-btn>
                    <cooling-load-explanation ref="explanationDialog"></cooling-load-explanation>
                </v-card-title>
                <v-card-text v-if="!loading">
                    <v-layout>
                        <v-flex xs12>
                            Forecast accuracy:
                            <vue-plotly v-if="data3" :data="data3" :layout="layout3" :options="options3"/>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
<!--        <v-flex xs12 v-show="!loading">-->
<!--            <v-card>-->
<!--                <v-card-text v-if="!loading">-->
<!--                    <vue-plotly v-if="data4" :data="data4" :layout="layout4" :options="options4"/>-->
<!--                </v-card-text>-->
<!--            </v-card>-->
<!--        </v-flex>-->

        <v-flex xs12 v-show="!loading">
            <anomaly-summary-view></anomaly-summary-view>
        </v-flex>



    </v-layout>
</template>

<script>
    import KPIValueBoxes from '../../components/kpi/KPIValueBoxes'
    import CoolingLoadStackedAreaPlot from '../../components/CoolingLoadStackedAreaPlot'
    import CoolingLoadForecastNew from '../../components/loadforecast/CoolingLoadForecastNew'
    import {callAPI,getResult} from '@/helper'
    import VuePlotly from '@/components/VuePlotly'
    import ValueBox from '@/components/ValueBox'
    import CoolingLoadExplanation from '@/components/CoolingLoadExplanation'
    import moment from 'moment'
    import AnomalySummaryView from "../AnomalySummaryView";



    export default {
        name: 'DefaultDashboard',
        components: { KPIValueBoxes,CoolingLoadStackedAreaPlot,CoolingLoadForecastNew,VuePlotly,ValueBox,CoolingLoadExplanation,AnomalySummaryView},
        computed: {
            savingPercentage () {
                if(this.totalSavingSum===0){
                    return 0;
                }
                return 100*this.totalSavingSum/(this.totalSavingSum+this.totalPowerSum);
            }
        },
        data () {
            return {
                range: {start: '2019-09-25', end: '2019-10-01'},
                loading:false,
                equipment: 'ACPC-2',
                forcedBlue:["2019-10-31 00:00:00","2019-10-29 00:00:00"],
                data:null,
                totalPowerSum:0,
                totalSavingSum:0,
                data2:null,
                data3:null,
                // data4:null,
                options: {},
                options2: {},
                options3: {},
                // options4: {},
                layout:{
                    shapes: [
                        {
                            type: 'line',
                            x0: 0,
                            y0: -6461.62,
                            x1: 40,
                            y1: 6339,
                            line:{
                                color: 'rgba(0, 0, 0,0.3)',
                                width: 1,
                                dash:'dot'
                            }
                        }
                    ],
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Average outdoor air temperature',
                        range:[21,35]
                    },
                    yaxis: {
                        title: 'Total energy consumption in kWh',
                        rangemode:'tozero',
                        range:[0,6000],
                    }
                },
                layout2:{
                    yaxis: {
                        title: 'Energy consumption'
                    },
                    xaxis: {
                        title: 'Date'
                    }
                },
                layout3:{
                    title: 'Cooling Load Accuracy',
                    hovermode: 'closest',
                    xaxis: {
                        title: 'Time',
                    },
                    yaxis: {
                        title: 'Cooling Load'
                    },
                },
                // layout4:{
                //     title: 'Cooling Load Accuracy Trend',
                //     hovermode: 'closest',
                //     xaxis: {
                //         title: 'Time',
                //     },
                //     yaxis: {
                //         title: 'Difference'
                //     },
                // }

            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            }
        },
        mounted() {
            let rangeStart = _.get(this.$route.query,'rangeStart', "2019-08-27")
            let rangeEnd =  _.get(this.$route.query,'rangeEnd', moment().subtract(1, "days").format('YYYY-MM-DD'))
            let me=this;
            me.loading=true;
            let promises=[];
            let timestamp=null;
            let totalPower=null;
            let avgTemp=null;
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(equip.equipment_type==='chiller'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['Comp_Power']
                        }
                    ))
                } else if(equip.equipment_type==='pump'){
                    promises.push(callAPI('data/',
                        {
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'equipment_name': equip.equipment_name,
                            'agg': 'D',
                            'agg_op': 'sum',
                            'date_range':[rangeStart, rangeEnd+" 23:59"],
                            'sensor_names': ['KW']
                        }
                    ))
                }
            }

            promises.push(callAPI('data/',
                {
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'equipment_name': 'ACPC-1',
                    'agg': 'D',
                    'agg_op': 'mean',
                    'date_range':[rangeStart, rangeEnd+" 23:59"],
                    'sensor_names': ['Outdoor_Air_Temperature']
                }
            ))


            Promise.all(promises).then(function(reses) {
                for (let res of reses){
                    if(!timestamp){
                        timestamp=res.data.timestamp;
                    }
                    if(res.data['Outdoor_Air_Temperature']){
                        avgTemp=res.data['Outdoor_Air_Temperature'];
                    } else {
                        if(!totalPower){
                            if(res.data['Comp_Power']){
                                totalPower=res.data['Comp_Power'];
                            } else if (res.data['KW']){
                                totalPower=res.data['KW'];
                            }
                        } else {
                            if(res.data['Comp_Power']){
                                totalPower=me.addArrays(totalPower,res.data['Comp_Power'])
                            } else if (res.data['KW']){
                                totalPower=me.addArrays(totalPower,res.data['KW'])
                            }
                        }
                    }

                }
                let preAvgTemp=[];
                let postAvgTemp=[];
                let preTotalPower=[];
                let postTotalPower=[];
                let preLabels=[];
                let postLabels=[];
                let totalPowerSum=0;
                let totalSavingSum=0;
                for (let k in timestamp){
                    if(timestamp[k]<="2019-09-18 00:00:00"||me.forcedBlue.includes(timestamp[k])){
                        preAvgTemp.push(avgTemp[k]);
                        preTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        preLabels.push(timestamp[k].substring(0, 10));
                    } else {
                        postAvgTemp.push(avgTemp[k]);
                        postTotalPower.push(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        totalPowerSum+=(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        totalSavingSum+=(320.32*avgTemp[k])-6461-(totalPower[k]/me.$store.state.pointsListStore.pointsList.sampling_freq);
                        postLabels.push(timestamp[k].substring(0, 10));
                    }
                }
                //206.958*x-3007.6
                me.totalPowerSum=totalPowerSum;
                me.totalSavingSum=totalSavingSum;

                me.data = [
                    {x: preAvgTemp, y: preTotalPower, type: 'scattergl', mode: 'markers' ,name:"Before optimisation",hovertext:preLabels},
                    {x: postAvgTemp, y: postTotalPower, type: 'scattergl', mode: 'markers',name:"After optimisation",hovertext:postLabels}
                ]
                let secondChartData = [];
                let colorMap={
                    "ACPC-1":"rgba(255, 127, 14,0.5)",
                    "ACPC-2":"rgba(214, 39, 40,0.5)",
                    "ACPC-3":"rgba(44, 160, 44, 0.5)",
                    "ACPC-4":"rgba(31, 119, 180,0.5)",
                    "ACPC-5": "rgba(148, 103, 189,0.5)",
                    "ACPC-6": "rgba(140, 86, 75,0.5)",
                    "ACPC-7": "rgba(227, 119, 194,0.5)",
                    "ACPC-8": "rgba(127, 127, 127,0.5)",
                    "ACPC-9": "rgba(188, 189, 34,0.5)",
                    "Chiller1": "rgba(255, 127, 14,0.5)",
                    "Chiller2": "rgba(214, 39, 40,0.5)",
                    "Chiller3": "rgba(44, 160, 44, 0.5)",
                    "Chiller4": "rgba(31, 119, 180,0.5)",
                    "Chiller5": "rgba(148, 103, 189,0.5)",
                    "Chiller6": "rgba(140, 86, 75,0.5)",
                    "Chiller7": "rgba(227, 119, 194,0.5)",
                    "Chiller8": "rgba(127, 127, 127,0.5)",
                    "Chiller9": "rgba(188, 189, 34,0.5)",
                };
                for (let res of reses) {
                    if (res.data['Comp_Power']) {
                        secondChartData.push({
                            x: timestamp,
                            y: res.data['Comp_Power'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                            name: JSON.parse(res.config.data)["equipment_name"],
                            fillcolor:colorMap[JSON.parse(res.config.data)["equipment_name"]],
                            hasOwnGraph:true,
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    } else if (res.data['KW']) {
                        secondChartData.push({
                            x: timestamp,
                            y: res.data['KW'].map(i=>i/me.$store.state.pointsListStore.pointsList.sampling_freq),
                            name: JSON.parse(res.config.data)["equipment_name"],
                            stackgroup: 'one',
                            type: 'scatter',
                            mode: 'none'
                        });
                    }
                }
                secondChartData.sort((a, b) => (a.name > b.name) ? 1 : -1)
                me.data2=secondChartData;
                me.loading=false;
            });

            getResult({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                result_name: 'cooling load'
            }).then(function(result){
                let actualdata = result['result'][0]['content']['df']
                let newdata = result['result'][0]['content']['forecast']
                me.data3=[
                    {
                        marker: {
                            color: 'rgb(0,0,0)',
                            shape: 'spline',
                            width: 1,
                            opacity: 0.9
                        },
                        x: actualdata.timestamp,
                        y: actualdata.total_CL,
                        name: 'Actual observed value',
                        type: 'scatter',
                        mode: 'lines'
                    },
                    {
                        line: {
                            color: 'rgb(0,76,255)',
                            shape: 'spline',
                            width: 1,
                            opacity: 0.9
                        },
                        x: newdata.timestamp,
                        y: newdata.yhat,
                        name: 'Predicted value',
                        type: 'scatter',
                        mode: 'lines'
                    },
                ]
                // let differential=[];
                // for(let tsindex in newdata.timestamp){
                //     let main=actualdata.total_CL[tsindex] ? actualdata.total_CL[tsindex] : 0
                //     if(main){
                //         differential.push(Math.abs((main-newdata.yhat[tsindex])/main * 100))
                //     } else {
                //         differential.push(0)
                //     }
                //
                // }
                // me.data4=[
                //     {
                //         x: newdata.timestamp,
                //         y: differential,
                //         name: 'Differential',
                //         type: 'scatter',
                //         mode: 'lines'
                //     },
                // ]
            });

        }


    }
</script>
<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
</style>
